import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-lab-hemato-cat',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './lab-hemato-cat.component.html',
  styleUrls: ['./lab-hemato-cat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabHematoCatComponent extends FormBaseComponent implements OnInit {
  @Output() formChange = new EventEmitter<any>();
  leftParams: Array<{ labelKey: string; control: string }> = [];
  unitMap: Record<string, string> = {};
  refMap: Record<string, string> = {};

  constructor() {
    super();
    this.form = this.fb.group({
      wbc: new FormControl(''),
      lymphCount: new FormControl(''),
      monCount: new FormControl(''),
      granCount: new FormControl(''),
      lymphPercent: new FormControl(''),
      monPercent: new FormControl(''),
      granPercent: new FormControl(''),
      rbc: new FormControl(''),
      hgb: new FormControl(''),
      hct: new FormControl(''),
      mcv: new FormControl(''),
      mch: new FormControl(''),
      mchc: new FormControl(''),
      rdw: new FormControl(''),
      plt: new FormControl(''),
      mpv: new FormControl(''),
      pdw: new FormControl(''),
      pct: new FormControl(''),
      eos: new FormControl(''),
      bloodSmear: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.leftParams = [
      { labelKey: 'WBC', control: 'wbc' },
      { labelKey: 'Lymph#', control: 'lymphCount' },
      { labelKey: 'Mon#', control: 'monCount' },
      { labelKey: 'Gran#', control: 'granCount' },
      { labelKey: 'Lymph%', control: 'lymphPercent' },
      { labelKey: 'Mon%', control: 'monPercent' },
      { labelKey: 'Gran%', control: 'granPercent' },
      { labelKey: 'RBC', control: 'rbc' },
      { labelKey: 'HGB', control: 'hgb' },
      { labelKey: 'HCT', control: 'hct' },
      { labelKey: 'MCV', control: 'mcv' },
      { labelKey: 'MCH', control: 'mch' },
      { labelKey: 'MCHC', control: 'mchc' },
      { labelKey: 'RDW', control: 'rdw' },
      { labelKey: 'PLT', control: 'plt' },
      { labelKey: 'MPV', control: 'mpv' },
      { labelKey: 'PDW', control: 'pdw' },
      { labelKey: 'PCT', control: 'pct' },
      { labelKey: 'EOS', control: 'eos' },
    ];

    this.unitMap = {
      wbc: 'x10^9/L',
      lymphCount: 'x10^9/L',
      monCount: 'x10^9/L',
      granCount: 'x10^9/L',
      lymphPercent: '%',
      monPercent: '%',
      granPercent: '%',
      rbc: 'x10^9/L',
      hgb: 'g/L',
      hct: '%',
      mcv: 'fL',
      mch: 'pg',
      mchc: 'g/L',
      rdw: '%',
      plt: 'x10^9/L',
      mpv: 'fL',
      pdw: '',
      pct: '%',
      eos: '%',
    };

    this.refMap = {
      wbc: '5.5 - 19.0',
      lymphCount: '0.8 - 7.0',
      monCount: '0.0 - 1.9',
      granCount: '2.1 - 15.0',
      lymphPercent: '12.0 - 45.0',
      monPercent: '2.0 - 9.0',
      granPercent: '35.0 - 85.0',
      rbc: '4.6 - 10.0',
      hgb: '93 - 153',
      hct: '28.0 - 49.0',
      mcv: '39.0 - 52.0',
      mch: '13.0 - 21.0',
      mchc: '300 - 380',
      rdw: '14.0 - 18.0',
      plt: '100 - 514',
      mpv: '5.0 - 11.8',
      pdw: '',
      pct: '',
      eos: '',
    };
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );
  }
}
